import React, { Component } from 'react';
import { Grid, Cell } from 'react-mdl';
import Particles from 'react-particles-js';

const particlesOptions = {
  "particles": {
      "number": {
          "value": 190,
          "density": {
              "enable": false
          }
      },
      "size": {
          "value": 5,
          "random": true,
          "anim": {
              "speed": 7,
              "size_min": 0.9
          }
      },
      "line_linked": {
          "enable": false
      },
      "move": {
          "random": true,
          "speed": 1,
          "direction": "top",
          "out_mode": "out"
      }
  },
  "interactivity": {
      "events": {
          "onhover": {
              "enable": true,
              "mode": "bubble"
          },
          "onclick": {
              "enable": true,
              "mode": "repulse"
          }
      },
      "modes": {
          "bubble": {
              "distance": 250,
              "duration": 2,
              "size": 0,
              "opacity": 0
          },
          "repulse": {
              "distance": 400,
              "duration": 4
          }
      }
  }
}

class Landing extends Component {
  render() {
    return(
      <div id="particle-canvas">
        <Particles params={particlesOptions}/>
        <Grid className="landing-grid" >
         
          <Cell col={12} className="landing-content">
            <div className="banner-text">
              <h1>Minquan Li</h1>

            <hr/>

            <p>Java | C | Python | JavaScript | React | NodeJS | Express | MongoDB</p>

            <div className="social-links">

            {/* LinkedIn */}
            <a href="https://www.linkedin.com/in/mqli" rel="noopener noreferrer" target="_blank">
              <i className="fa fa-linkedin-square" aria-hidden="true" />
            </a>
  
            {/* Github */}
            <a href="https://github.com/limmil" rel="noopener noreferrer" target="_blank">
              <i className="fa fa-github-square" aria-hidden="true" />
            </a>

            </div>
            </div>
          </Cell>
        </Grid>
      </div>
    )
  }
}

export default Landing;
